import { Component, OnInit } from '@angular/core';
import { ToastController } from '@ionic/angular';
import { BerService } from '../ber.service';

// BER beállítások: évenkénti számfejtési paraméterek (minimálbér, kulcsok, kedvezmény-összegek).
@Component({
  selector: 'app-ber-beallitasok',
  templateUrl: './beallitasok.component.html',
  styleUrls: ['../../naplo/naplo-shared.scss', '../ber-shared.scss'],
})
export class BeallitasokComponent implements OnInit {
  intezmeny = '';
  evek: number[] = [];
  ev = new Date().getFullYear();
  be: any = null;
  mentes = false;

  constructor(private ber: BerService, private toast: ToastController) {}

  async ngOnInit() {
    const a = await this.ber.init();
    this.intezmeny = a.intezmeny;
    this.ev = a.ev;
    const ev = new Date().getFullYear();
    this.evek = [ev + 1, ev, ev - 1, ev - 2, ev - 3];
    await this.betolt();
  }

  async evValt(ev: number) { this.ev = ev; await this.betolt(); }

  async betolt() {
    try {
      this.be = await this.ber.get('/beallitas/' + this.intezmeny + '?ev=' + this.ev);
      ['szja_kulcs', 'tb_kulcs', 'szocho_kulcs'].forEach((k) => { this.be[k] = Math.round(Number(this.be[k]) * 1000) / 10; }); // %-ban szerkesztünk
    } catch { this.hiba('Nem sikerült betölteni.'); }
  }

  async ment() {
    this.mentes = true;
    try {
      const payload = { ...this.be, szja_kulcs: Number(this.be.szja_kulcs) / 100, tb_kulcs: Number(this.be.tb_kulcs) / 100, szocho_kulcs: Number(this.be.szocho_kulcs) / 100 };
      await this.ber.put('/beallitas/' + this.intezmeny + '?ev=' + this.ev, payload);
      this.ok('Beállítások mentve.');
    } catch (e: any) { this.hiba(e?.error?.error || 'Mentési hiba.'); }
    finally { this.mentes = false; }
  }

  private async ok(m: string) { (await this.toast.create({ message: m, duration: 1600, color: 'success' })).present(); }
  private async hiba(m: string) { (await this.toast.create({ message: m, duration: 2600, color: 'danger' })).present(); }
}
